const PATH = 'fe.components.trainings.view.details.reliability_report';

const messages = {
  headerCombined: {
    key: `${PATH}.header_combined`,
    defaultValue: 'Participant Reliability/Knowledge'
  },
  viewCombinedReport: {
    key: `${PATH}.view_combined_report`,
    defaultValue: 'View Reliability/Knowledge Report'
  },
  combinedReportTitle: {
    key: `${PATH}.combined_report_title`,
    defaultValue: 'Training Reliability/Knowledge Report'
  },
  reliabilityLabel: {
    key: `${PATH}.reliability_label`,
    defaultValue: 'Reliability'
  },
  reliableLabel: {
    key: `${PATH}.reliable_label`,
    defaultValue: 'Reliable'
  },
  knowledgeLabel: {
    key: `${PATH}.knowledge_label`,
    defaultValue: 'Knowledge'
  },
  loading: {
    key: `${PATH}.loading`,
    defaultValue: 'Loading report data...'
  },
  header: {
    key: `${PATH}.header`,
    defaultValue: 'Participant Reliability'
  },
  viewReport: {
    key: `${PATH}.view_report`,
    defaultValue: 'View Reliability Report'
  },
  headerKnowledge: {
    key: `${PATH}.header_knowledge`,
    defaultValue: 'Participant Knowledge'
  },
  viewKnowledgeReport: {
    key: `${PATH}.view_knowledge_report`,
    defaultValue: 'View Knowledge Report'
  },
  errorMessage: {
    key: `${PATH}.error_message`,
    defaultValue:
      'We couldn’t load your test. Please contact support via the chat or at'
  }
};

export default messages;
